module.exports = ":host {\n    /* not working? */\n    padding: 15px;\n    margin: 15px;\n}\npaper-input {\n    margin: 15px;\n}"